import script from "./FindIdPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FindIdPage.vue?vue&type=script&setup=true&lang=ts"

import "./FindIdPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__